// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginPage-module__page--tZxPn {
  min-width: 0;
  min-height: 100vh;
  background: #090a0c;
}

.LoginPage-module__main--Uhoof {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 440px);
  min-height: 800px;
  padding: 118px 24px 78px;
  margin: 0 auto;
  color: #fcfaf7;
}

.LoginPage-module__loginButtons--ea6Lp {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 50px;
}

@media (max-height: 799px) {
  .LoginPage-module__main--Uhoof {
    min-height: 100vh;
    padding-top: clamp(56px, 14.75vh, 118px);
    padding-bottom: 48px;
  }

  .LoginPage-module__loginButtons--ea6Lp {
    margin-top: clamp(32px, 6.25vh, 50px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage/LoginPage.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,wCAAwC;IACxC,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".page {\n  min-width: 0;\n  min-height: 100vh;\n  background: #090a0c;\n}\n\n.main {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: min(100%, 440px);\n  min-height: 800px;\n  padding: 118px 24px 78px;\n  margin: 0 auto;\n  color: #fcfaf7;\n}\n\n.loginButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  margin-top: 50px;\n}\n\n@media (max-height: 799px) {\n  .main {\n    min-height: 100vh;\n    padding-top: clamp(56px, 14.75vh, 118px);\n    padding-bottom: 48px;\n  }\n\n  .loginButtons {\n    margin-top: clamp(32px, 6.25vh, 50px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `LoginPage-module__page--tZxPn`,
	"main": `LoginPage-module__main--Uhoof`,
	"loginButtons": `LoginPage-module__loginButtons--ea6Lp`
};
export default ___CSS_LOADER_EXPORT___;
